import * as d3 from 'd3-selection'
import * as dataset from './dataset.js'

/*
 * Parses a native select options, returning an array of data
 * options
 */
export default function (select) {
  return d3.select(select)
           .selectAll('option:not([data-filtering-default])')
           .nodes()
           .map(function (opt, i) {
             return {
               native: true, // Set a flag indicating this option was parsed from a native select
               label: opt.innerHTML,
               value: opt.value,
               clazz: opt.className,
               disabled: opt.disabled,
               // Determine if the option is selected. The or is for IE11 - In IE11, if the value of the
               //   select was set to an option that isn't in the list, the option won't have `selected = true`,
               //   even though the value of the select itself equals that options value.
               selected: opt.selected || opt.value === select.value,
               dataset: dataset.parse(opt)
             }
           })
}
